
/**
 * 导出当前仓库 npm 版本
 */

// TODO: this is special because it gets imported during pub.
const version = '0.1.35-hotfix1';

export default version;
